import { cn } from "@/lib/utils";
import { fmtNum } from "@/lib/format";

export const Kpi = ({ label, value, sub, tone = "default", testId, icon: Icon }) => {
  const tones = {
    default: "text-foreground",
    primary: "text-primary",
    good: "text-emerald-500",
    warn: "text-amber-500",
    bad: "text-red-500",
  };
  return (
    <div className="border border-border bg-card p-3 rise min-w-0" data-testid={testId}>
      <div className="flex items-center justify-between gap-2">
        <span className="text-[11px] uppercase tracking-wider text-muted-foreground font-semibold">{label}</span>
        {Icon ? <Icon className="w-4 h-4 text-muted-foreground" /> : null}
      </div>
      <div className={cn("num text-2xl font-semibold mt-1.5 leading-none", tones[tone])}>{value}</div>
      {sub ? <div className="text-[11px] text-muted-foreground mt-1.5">{sub}</div> : null}
    </div>
  );
};

export const Badge2 = ({ children, tone = "muted", testId }) => {
  const tones = {
    muted: "bg-muted text-muted-foreground border-border",
    primary: "bg-primary/10 text-primary border-primary/30",
    good: "bg-emerald-500/10 text-emerald-500 border-emerald-500/30",
    warn: "bg-amber-500/10 text-amber-500 border-amber-500/30",
    bad: "bg-red-500/10 text-red-500 border-red-500/30",
  };
  return (
    <span
      data-testid={testId}
      className={cn("inline-flex items-center border px-1.5 py-0.5 text-[10px] uppercase tracking-wide font-semibold rounded", tones[tone])}
    >
      {children}
    </span>
  );
};

export const Bar = ({ pct, tone }) => {
  const p = Math.max(0, Math.min(100, Number(pct) || 0));
  const color = tone || (p >= 90 ? "bg-emerald-500" : p >= 60 ? "bg-primary" : p >= 30 ? "bg-amber-500" : "bg-red-500");
  return (
    <div className="flex items-center gap-2 min-w-[110px]">
      <div className="h-1.5 flex-1 bg-muted rounded overflow-hidden">
        <div className={cn("h-full rounded", color)} style={{ width: `${p}%`, transition: "width 400ms ease" }} />
      </div>
      <span className="num text-[11px] text-muted-foreground w-10 text-right">{fmtNum(p, 1)}%</span>
    </div>
  );
};

export const Panel = ({ title, action, children, className, testId }) => (
  <section className={cn("border border-border bg-card min-w-0", className)} data-testid={testId}>
    <header className="flex items-center justify-between gap-3 border-b border-border px-3 py-2">
      <h3 className="text-sm font-semibold">{title}</h3>
      {action}
    </header>
    <div className="p-3">{children}</div>
  </section>
);

export const PageHead = ({ title, subtitle, children }) => (
  <div className="flex flex-wrap items-end justify-between gap-3 mb-4">
    <div>
      <h1 className="text-2xl sm:text-3xl font-semibold">{title}</h1>
      {subtitle ? <p className="text-sm text-muted-foreground mt-1">{subtitle}</p> : null}
    </div>
    <div className="flex items-center gap-2 flex-wrap">{children}</div>
  </div>
);
